export function metersToMiles(meters) {
  if (!meters) {
    return "";
  }

  return window.parseFloat((meters / 1609.344).toFixed(2));
}
export function milesToMeters(miles) {
  if (!miles) {
    return "";
  }

  return miles * 1609.344;
}